import React from 'react';
import PropTypes from 'prop-types';

import { ErrorBoundary } from 'wsm-error-boundary';
import logger from 'ws-scripts/modules/logger';

const ErrorBoundaryWrapper = ({ children }) => (
	<ErrorBoundary
		newRelicPageAction="WS VEHICLE CTAS ERROR BOUNDARY"
		errorHandler={(error, errorInfo) => {
			const newError = new Error(
				`Encountered an error in ws-vehicle-ctas.\n${error}`
			);
			newError.originalError = error;
			newError.originalStackTrace = errorInfo.componentStack;
			logger.error(`${newError}\n${newError.originalStackTrace}`);
		}}
	>
		{children}
	</ErrorBoundary>
);

export default ErrorBoundaryWrapper;

ErrorBoundaryWrapper.propTypes = {
	children: PropTypes.node.isRequired
};
